import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Pickup(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11 8.5A4.5 4.5 0 0115.5 4a1 1 0 100-2 6.503 6.503 0 00-6.326 5H4a1 1 0 000 2h.895l-.8 8H3a1 1 0 100 2h4v2a1 1 0 102 0v-2h5a1 1 0 100-2h-1.095l-.266-2.662A6.5 6.5 0 0022 8.5c0-1.668-.622-3.036-1.793-4.207a1 1 0 00-1.454.043l-3.644 4.1-1.25-1.25a1 1 0 10-1.415 1.413l2 2a1 1 0 001.455-.042l3.567-4.014C19.83 7.132 20 7.766 20 8.5a4.5 4.5 0 11-9 0zM6.905 9l-.8 8h4.79l-.44-4.4v-.001A6.47 6.47 0 019.019 9H6.905z",
    clipRule: "evenodd"
  }));
}

export default Pickup;